import { jsxs as o, jsx as t } from "react/jsx-runtime";
const C = () => /* @__PURE__ */ o("svg", { fill: "none", height: "18", viewBox: "0 0 20 18", width: "20", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ t(
    "path",
    {
      d: "M14.4589 4.47141C14.4589 6.66205 12.5385 8.49282 10.0995 8.49282C7.66044 8.49282 5.74013 6.66205 5.74013 4.47141C5.74013 2.28076 7.66044 0.45 10.0995 0.45C12.5385 0.45 14.4589 2.28076 14.4589 4.47141Z",
      stroke: "currentColor",
      strokeWidth: "0.9"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M13.7032 9.6792C13.8525 9.59587 13.9952 9.54178 14.1258 9.52386C15.5923 9.32266 16.6629 10.1477 17.474 11.4808C18.288 12.8187 18.7698 14.5701 19.0421 15.9478C19.2074 16.7837 18.5501 17.55 17.6336 17.55H1.86107C1.03722 17.55 0.441044 16.9299 0.518176 16.2061C0.751772 14.014 1.70364 10.6286 5.25412 9.41485C5.57056 9.30667 5.93954 9.34702 6.28091 9.51709C7.84005 10.2938 8.96048 10.7808 10.0715 10.8319C11.2042 10.8841 12.2624 10.4834 13.7032 9.6792Z",
      stroke: "currentColor",
      strokeWidth: "0.9"
    }
  )
] });
export {
  C as AccountIcon
};
